import React from "react";
import { PageContainer } from "../../components/common/PageContainer";
import Detail from "./detail";

const Dashboard = () => {
    return <PageContainer breadcrumbTitle="Dashboard" component={Detail} />;
};

export default Dashboard;
